import React, { useState, useEffect } from 'react'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import './home-style.scss'
import { FetchDashboarddataNew } from '../../services/api'
import Prgraph from './components/Prgraph/Prgraph'
import Yieldgraph from './components/Yieldgraph/Yieldgraph'
import EnergyGraph from './components/EnergyGraph/EnergyGraph'
import PotfolioRepGraph from './components/PotfolioRepGraph/PotfolioRepGraph'
import AnimatedLoader from '../../components/AnimatedLoader/AnimatedLoader.jsx'
import CustomAlert from '../../components/CustomAlert/CustomAlert.jsx'
import { useLocation } from 'react-router-dom'

const Home = () => {
  const [dashboardData, setDashboardData] = React.useState([])
  const [userData, setUserData] = React.useState({})
  const [loading, setLoading] = useState(true)
  const [loginSuccessHome, setLoginSuccesshome] = useState(false)
  const { state } = useLocation()

  useEffect(() => {
    setLoginSuccesshome(state?.loginSuccess)
  }, [state?.loginSuccess])

  useEffect(() => {
    HandleDashboarddata()
  }, [])
  const token = localStorage.getItem('accessToken')
  const HandleDashboarddata = () => {
    const Usertype = localStorage.getItem('userType')
    const UserID = localStorage.getItem('userId')
    const Username = Usertype?.charAt(0).toUpperCase() + Usertype?.slice(1)
    setUserData({
      Usertype: Username,
      UserID: UserID,
    })
    let IdUser
    if (Usertype === 'user') {
      IdUser = UserID
    } else if (Usertype === 'admin') {
      IdUser = 'all'
    }
    FetchDashboarddataNew(IdUser, token).then((resp) => {
      if (resp?.data) {
        localStorage.setItem('Authorised', true)
        setDashboardData(resp?.data)
        setLoading(false)
      } else {
        if (resp?.response?.data?.statusCode === 401) {
          localStorage.setItem('Authorised', false)
        }
      }
    })
  }

  const alertClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    setLoginSuccesshome(false)
  }

  return (
    <>
      <CustomAlert
        open={loginSuccessHome}
        handleClose={alertClose}
        message="You are successfully logged in"
      />

      {loading ? (
        <AnimatedLoader style={{ height: '40px', width: '40px' }} />
      ) : (
        <Box>
          <Grid container spacing={2} className="mb_20">
            <Grid item xs={12} md={5}>
              <div className="hello_txt">Hello, {userData?.Usertype}</div>
              <div className="welcome_txt">Welcome Back</div>
            </Grid>
            <Grid item xs={12} md={3}></Grid>
            <Grid item xs={6} md={2}>
              <div className="total_plants">
                <div className="total_plants_title">Total Plants</div>
                <div className="h2">{dashboardData?.count}</div>
              </div>
            </Grid>
            <Grid item xs={6} md={2}>
              <div className="total_size">
                <div className="total_plants_title">Total Size (MW)</div>
                <div className=" h2" style={{ textAlign: 'center' }}>
                  {parseFloat(dashboardData?.totalPlantSize / 1000).toFixed(4)}{' '}
                </div>
              </div>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <Prgraph token={token} />
            </Grid>
            <Grid item xs={12} md={6}>
              <Yieldgraph token={token} />
            </Grid>
            <Grid item xs={12} md={6}>
              <EnergyGraph token={token} />
            </Grid>
            <Grid item xs={12} md={12}>
              <div className="graph_bg">
                <div className="h1 mb_10">Portfolio Representation</div>
                <Grid container>
                  <Grid xs={12} md={12}>
                    <PotfolioRepGraph token={token} />
                  </Grid>
                </Grid>
              </div>
            </Grid>
          </Grid>
        </Box>
      )}
    </>
  )
}

export default Home
